import { useInfiniteQuery } from 'react-query';
import { SubmissionQueryParams } from '../types';
import { submissionQueryArgs } from '../queryArgs';
import { getQuestionnaireSubmissionListUrl } from '../urls';
import {
  getClioQuestionnaireAuthToken,
  questionnaireAuthorizationHeaders,
} from '../utils';
import { APIError } from '~/src/utils/error';

export const useClioQuestionnaireSubmissions = (
  orgFprint: string,
  parameters: Partial<SubmissionQueryParams> = { limit: 15 },
) =>
  useInfiniteQuery(
    submissionQueryArgs.list(parameters),
    async ({ pageParam }) => {
      const params = { ...parameters, offset: pageParam || 0 };
      const token = await getClioQuestionnaireAuthToken(orgFprint);
      const response = await fetch(getQuestionnaireSubmissionListUrl(params), {
        headers: questionnaireAuthorizationHeaders(token),
      });

      if (!response.ok) {
        throw new APIError(
          'Failed to retrieve list of questionnaire submissions',
          response,
        );
      }

      const submissions = await response.json();

      return { submissions, params };
    },
    {
      getNextPageParam: ({ submissions, params }) =>
        submissions.length === params.limit
          ? params.offset + params.limit
          : undefined,
    },
  );
